<template>
	<div>
		<table class="cabecera-table w-100">
			<thead>
				<tr>
					<th>ARTÍCULO</th>
					<th>CANTIDAD</th>
					<th>PRECIO UNITARIO</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(item, index) in productsSelected"
					:key="index"
					class="bgWhite wrap"
				>
					<td>
						<rows-table :item="item" />
					</td>
					<td>
						<button-quantity
							:quantity="item.quantity"
							@on-add="add(item)"
							@on-sub="sub(item)"
						/>
					</td>
					<td>{{ getCurrencySymbol }} {{ item.salePrice || item.priceDiscount | priceFormat }}</td>
					<td>
						<button
							class="btn-cancel"
							type="button"
							@click="deleteProduct(index)"
						>
							X
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<p class="bar-table flex-70"></p>
		<div class="flex-70 d-flex justify-end quantity-article">
			<p class="total-text">Total <span>({{quantityArticle}})</span></p>
			<p class="total-text">{{getCurrencySymbol}} {{getTotalAmount | round(2)}}</p>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import rowsTable from '@/components/rowsTable';
import buttonQuantity from '@/components/buttonQuantity';
import lib from '@/helpers/lib';

const { removeItemFromArrayByIndex } = lib;

function add(row) {
	const newQuantity = row.quantity + 1;
	this.$set(row, 'quantity', newQuantity);
	this.$store.dispatch('UPDATE_ITEM_IN_PRODUCT_SELECTED', row);
}

function sub(row) {
	if (row.quantity >= 1) {
		const newQuantity = row.quantity - 1;
		this.$set(row, 'quantity', newQuantity);
		this.$store.dispatch('UPDATE_ITEM_IN_PRODUCT_SELECTED', row);
	}
}

function deleteProduct(index) {
	this.$store.commit(
		'UPDATE_PRODUCTS_SELECTED',
		removeItemFromArrayByIndex(index, this.productsSelected),
	);
}

function quantityArticle() {
	const msg = this.getTotalQuantity > 1 ? 'articulos' : 'articulo';
	return `${this.getTotalQuantity} ${msg}`;
}

export default {
	name: 'buy-table',
	components: {
		buttonQuantity,
		rowsTable,
	},
	computed: {
		...mapGetters([
			'getCurrencySymbol',
			'totalProductsQuantity',
			'getTotalAmount',
			'getTotalQuantity',
			'orderSummaryInfo',
			'productsSelected',
		]),
		quantityArticle,
	},
	methods: {
		add,
		deleteProduct,
		sub,
	},
};
</script>
<style lang="scss" scoped>
	.cabecera-table {
		background-color: color(grayMedium);
		border-collapse: collapse;
		font-family: font(open-semibold);
		font-size: size(medium);

		@media (max-width: 425px) {
			font-size: size(small);
		}

		tbody {

			tr {
				border-bottom: 0.1rem solid color(leadLight);
			}
		}
	}

	.btn-cancel {
		background: none;
		border-radius: 1.5rem;
		font-family: font(open-bold);
		font-size: size(maxsmall);
	}

	.bar-table {
		background-color: color(grayMedium);
		border: 0.1rem solid color(leadLight);
		height: 2.7rem;

		@media screen and (max-width: 425px) {
			display: none;
		}
	}

	.quantity-article {
		@media screen and (max-width: 425px) {
			display: none;
		}
	}

	td {
		border: 0;
		text-align: center;
	}

	.total-text {
		font-family: font(open-bold);
		font-size: size(medium);
		margin-left: 3rem;
	}
</style>




// WEBPACK FOOTER //
// buyTable.vue?d7595376